export default {
    'delete-message-permission': 'هل أنت متأكد من أنك تريد حذف هذا الأذن؟'
}